export const ERROR = "ERROR";
export const UNDEFINED = "UNDEFINED";
export const PING_PEDDING = "PING_PEDDING";
export const PING_SUCCESS = "PING_SUCCESS";
export const PING_FAILED = "PING_FAILED";
export const CONNECT_FAILED = "CONNECT_FAILED";
export const DISCONNECT = "DISCONNECT";
export const CHECK_SUCCESS = "CHECK_SUCCESS";
export const HAS_LOGGED = "HAS_LOGGED";
export const LOGGED_OUT = "LOGGED_OUT";
export const LS_COMPLETE = "LS_COMPLETE";
export const START_UPLOAD = "START_UPLOAD";
export const START_DOWNLOAD = "START_DOWNLOAD";
export const RECEIVE_PREFERENCE = "RECEIVE_PREFERENCE";
export const RECEIVE_FILES_LIST = "RECEIVE_FILES_LIST";
export const RECEIVE_REPORT = "RECEIVE_REPORT";
export const RECEIVE_TASK_COUNT = "RECEIVE_TASK_COUNT";
export const HAS_UPGRADE_VERSION = "HAS_UPGRADE_VERSION";
export const RECEIVE_ERROR_INFO = "RECEIVE_ERROR_INFO";
export const SERVER_UNAVAILABLE = "SERVER_UNAVAILABLE";
export const SERVER_DISCOVERING = "SERVER_DISCOVERING";
export const UPLOAD = "UPLOAD"; // 上传
export const UPDATE_ALL_NORMAL_TASK = "update_all_normal_task"; // 切换线路后更新传输信息
